import type { WorkspaceResponseV2 } from '@emma/api_client/types';
import { FileTable } from '@/components/file';

type Props = {
  workspace: WorkspaceResponseV2;
};

export const WorkspaceFilesSubPage = (props: Props) => {
  return <FileTable workspaceId={props.workspace.id} />;
};
